import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegistrousuarioComponent } from './componentes/registrousuario/registrousuario.component';
import { LoginComponent } from './componentes/login/login.component';
import { MenuusuarioComponent } from './componentes/menuusuario/menuusuario.component';
import { SeccionMisactividadesComponent } from './componentes/seccion-misactividades/seccion-misactividades.component';
import {GuardiaAutGuard} from '../app/guard/guardia-aut.guard'
import { SeccionAjustesComponent } from './componentes/seccion-ajustes/seccion-ajustes.component';
import { SeccionHistorialComponent } from './componentes/seccion-historial/seccion-historial.component';
import { EditorsopaComponent } from './componentes/editorsopa/editorsopa.component';
import { AccesoactividadComponent } from './componentes/accesoactividad/accesoactividad.component';
import { RealizadorsopaComponent } from './componentes/realizadorsopa/realizadorsopa.component';
import { EditorsecuenciaComponent } from './componentes/editorsecuencia/editorsecuencia.component';
import { RealizadorsecuenciaComponent } from './componentes/realizadorsecuencia/realizadorsecuencia.component';
import { EditorcuestionarioComponent } from './componentes/editorcuestionario/editorcuestionario.component';
import { RealizadorcuestionarioComponent } from './componentes/realizadorcuestionario/realizadorcuestionario.component';
import { SeccionPresentacionComponent } from './componentes/seccion-presentacion/seccion-presentacion.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'registro', component: RegistrousuarioComponent},
  { path: 'presentacion', component: SeccionPresentacionComponent},
  {
    path: 'menuusuario', component: MenuusuarioComponent,canActivate: [GuardiaAutGuard], children: [
      { path: 'misactividades', component:SeccionMisactividadesComponent },
      { path: 'ajustes', component:SeccionAjustesComponent },
      { path: 'historial', component:SeccionHistorialComponent},
    ]
  },
  { path: 'editorsopa', component: EditorsopaComponent ,canActivate: [GuardiaAutGuard]},
  { path: 'editorsecuencia', component:EditorsecuenciaComponent,canActivate: [GuardiaAutGuard]},
  { path: 'editorcuestionario', component:EditorcuestionarioComponent,canActivate: [GuardiaAutGuard]},
  { path: 'accederactividad', component: AccesoactividadComponent},
  { path: 'actividadsopa/:clave', component:RealizadorsopaComponent},
  { path: 'actividadsecuencia/:clave', component:RealizadorsecuenciaComponent},
  { path: 'actividadcuestionario/:clave', component:RealizadorcuestionarioComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
